import {
  FormattingTab,
  type FormattingTabProps,
} from '@ardoq/perspectives-sidebar';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { connect } from '@ardoq/rxbeach';
import { formattingTab$ } from 'perspectiveSidebar/perspectiveEditor/formattingTab$';
import { ViewOptionsPerspectivesPage as ViewOptionsPerspectivesPageBase } from './ViewOptionsPerspectivesPage';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

type ViewOptionsConditionalFormatProps = FormattingTabProps & {
  onClickOutside?: VoidFunction;
  i18nLocale: I18nLocale;
};

const ViewOptionsConditionalFormat = ({
  onClickOutside,
  i18nLocale,
  ...props
}: ViewOptionsConditionalFormatProps) => (
  <ViewOptionsPerspectivesPageBase
    title={t(
      i18nLocale,
      'appLayout:conditionalFormatPageTitle',
      'Conditional format'
    )}
    isNew
    onClickOutside={onClickOutside}
    shareFeedbackUrl={KnowledgeBaseLink.CONDITIONAL_FORMATTING_FEEDBACK}
  >
    <FormattingTab {...props} i18nLocale={i18nLocale} />
  </ViewOptionsPerspectivesPageBase>
);

export const ViewOptionsPerspectivesConditionalFormat = connect(
  ViewOptionsConditionalFormat,
  combineLatest([formattingTab$, i18nLocale$]).pipe(
    map(([props, i18nLocale]) => ({ ...props, i18nLocale }))
  )
);
